import { render, staticRenderFns } from "./FamilyHeathHistory.vue?vue&type=template&id=492702de&"
import script from "./FamilyHeathHistory.vue?vue&type=script&lang=js&"
export * from "./FamilyHeathHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports